import React, { useCallback, useMemo } from "react";
import { Button, Typography } from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../../Datatables/Datatable.table";
import Constants from "../../../../config/constants";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import useDocTableHook from "./DocTable.hook";
import { removeUnderScore } from "../../../../helper/Helper";

const DocTableComp = ({ data, handleDetail, sortDocTable, sortTable }) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    currentData,
    currentPage,
  } = useDocTableHook({ data });

  const tableStructure = useMemo(
    () => [
      {
        key: "doctor",
        label: "Doctor Name",
        sortable: false,
        render: (temp, all) => <div>{removeUnderScore(all?.doctor?.name)}</div>,
      },
      {
        key: "program",
        label: "Program",
        sortable: false,
        render: (temp, all) => <div>{all?.program?.name ?? "-"}</div>,
      },
      {
        key: "patient",
        label: "Patient Enrolment Count",
        sortable: false,
        render: (temp, all) => <div>{all?.enrollment ?? "-"}</div>,
      },
      {
        key: "dropout",
        label: "Patient Dropout Count",
        sortable: false,
        render: (temp, all) => <div>{all?.dropout ?? "-"}</div>,
      },
    ],
    [handleDetail]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]);

  return (
    <div className={styles.wrapper}>
      <ShadowBox className={styles.w100}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            Doctor performance
          </Typography>
        </div>
        <div>
          <div className={styles.buttons}>
            <Button
              variant={sortTable === "top10" ? "contained" : "outlined"}
              color="primary"
              className={`${styles.btnClass} ${
                sortTable === "top10" ? styles.activeBtn : styles.nonActiveBtn
              }`}
              onClick={() => sortDocTable("top10")}
            >
              Top 10
            </Button>
            <Button
              variant={sortTable === "bottom10" ? "contained" : "outlined"}
              color="primary"
              className={`${styles.btnClass} ${
                sortTable === "bottom10"
                  ? styles.activeBtn
                  : styles.nonActiveBtn
              }`}
              onClick={() => sortDocTable("bottom10")}
            >
              Bottom 10
            </Button>
          </div>
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                width="100%"
                {...tableData.datatable}
                {...tableData.datatableFunctions}
                hidePagination={true}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default DocTableComp;
